export default __webpack_public_path__ + "static/media/pedestrian-icon.fd7bf62a.png";